const setUpBoard = () => {
  // Function to generate vertical black squares
  const generateVerticalSquares = (x, startY, endY) => {
    const squares = [];
    for (let y = startY; y <= endY; y += 32) {
      squares.push({ x, y });
    }
    return squares;
  };


  // Function to generate horizontal black squares
  const generateHorizontalSquares = (y, startX, endX) => {
    const squares = [];
    for (let x = startX; x <= endX; x += 32) {
      squares.push({ x, y });
    }
    return squares;
  };

  const blackSquares = [
    { x: 0, y: 0 },
    { x: 1152 - 32, y: 0 },
    { x: 0, y: 768 - 32 },
    { x: 1152 - 32, y: 768 - 32 },
    ...generateVerticalSquares(7 * 32, 1 * 32, 22 * 32),
    ...generateVerticalSquares(18 * 32, 1 * 32, 22 * 32),
    ...generateHorizontalSquares(5 * 32, 19 * 32, 34 * 32),
    ...generateHorizontalSquares(8 * 32, 19 * 32, 34 * 32),
    ...generateHorizontalSquares(11 * 32, 19 * 32, 34 * 32),
    ...generateHorizontalSquares(14 * 32, 19 * 32, 34 * 32),
    ...generateHorizontalSquares(17 * 32, 19 * 32, 34 * 32),
    ...generateHorizontalSquares(20 * 32, 19 * 32, 34 * 32),
  ];

  const edgeSquares = [];
  for (let x = 0; x < 1152; x += 32) {
    edgeSquares.push({ x, y: 0 }, { x, y: 768 - 32 });
  }
  for (let y = 0; y < 768; y += 32) {
    edgeSquares.push({ x: 0, y }, { x: 1152 - 32, y });
  }

  return [...edgeSquares, ...blackSquares]
};

export default setUpBoard;